import React, { useRef, useState } from "react";
import SignaturePad from "react-signature-canvas";
import { Button, Container } from "react-bootstrap";

const Step10SignaturePage = ({ form, setForm, prevStep, handleComplete }) => {
  const sigPadRef = useRef(null);
  const [showSignaturePad, setShowSignaturePad] = useState(!form.user_signature);

  const handleSubmit = async () => {
    let signatureData = form.user_signature || null;

    if (showSignaturePad) {
      if (sigPadRef.current?.isEmpty()) {
        alert("Please add your signature before submitting.");
        return;
      }

      signatureData = sigPadRef.current?.getCanvas().toDataURL("image/png");
      setForm((prev) => ({ ...prev, user_signature: signatureData }));
    }

    if (!signatureData) {
      alert("Please add your signature before submitting.");
      return;
    }

    await handleComplete(signatureData);
  };

  return (
    <Container className="my-5">
      <h4 className="mb-4">Add Signature</h4>
      <p className="text-muted">
        This signature will be saved to your account and copied onto future HR tasks.
      </p>

      {!showSignaturePad && form.user_signature ? (
        <div className="border rounded bg-white p-3 mb-4">
          <img
            src={form.user_signature}
            alt="Saved signature"
            style={{ maxWidth: "100%", maxHeight: "180px" }}
          />
          <div className="mt-3">
            <Button
              variant="secondary"
              type="button"
              onClick={() => setShowSignaturePad(true)}
            >
              Re-do My Signature
            </Button>
          </div>
        </div>
      ) : (
        <div className="border rounded bg-white p-3 mb-4">
          <SignaturePad
            ref={sigPadRef}
            canvasProps={{
              style: {
                width: "100%",
                height: "220px",
                border: "1px solid #d6d9de",
                borderRadius: "8px",
              },
            }}
          />
          <div className="mt-3 d-flex gap-2">
            <Button
              variant="outline-secondary"
              type="button"
              onClick={() => sigPadRef.current?.clear()}
            >
              Clear Signature
            </Button>
            {form.user_signature && (
              <Button
                variant="outline-secondary"
                type="button"
                onClick={() => setShowSignaturePad(false)}
              >
                Keep Existing Signature
              </Button>
            )}
          </div>
        </div>
      )}

      <div className="d-flex justify-content-between mt-4">
        <Button variant="secondary" onClick={prevStep}>
          Back
        </Button>
        <Button variant="primary" onClick={handleSubmit}>
          Submit
        </Button>
      </div>
    </Container>
  );
};

export default Step10SignaturePage;
